import { RootState } from '@reducers';

export const selectCancerQuoteBuyRoute = (state: RootState) => state.cancerQuoteBuyRouteReducer;
